import { useState } from 'react';
import Typography from '../../../components/Typography';
import Api from '../../../config';
import PaginatedTable from '../../../components/table/Paginated-table';
import { getJSONheader } from '../../../utils';
import { CASE_CAUSELIST_COLUMNS } from '../../../components/table/columns/judge';

function Judges() {
	const [data, setData] = useState([]);
	const [totalPages, setTotalPages] = useState(0);
	const [isLoading, setLoading] = useState(false);

	const fetchData = async (page: any, pageSize: any) => {
		setLoading(true);
		try {
			const response = await Api.get(`/judge-magistrate/cause-lists`, getJSONheader());
			const { data, meta } = response.data;
			setLoading(false);
			setData(data);
			setTotalPages(meta.last_page);
		} catch (error) {
			setLoading(false);
			console.error('Error fetching data:', error);
		}
	};

	return (
		<div className='pt-4 px-8 pb-36 lg:pb-0'>
			<Typography textStyle='text-[20px] font-medium'>Cause List</Typography>
			<div className='w-full  pb-20 lg:pb-0'>
				<div className='w-full flex flex-row justify-between items-start pl-5 pt-4 lg:pt-0'></div>

				<div className='mt-8 lg:flex justify-between items-end'>
					<div className=' w-full lg:mb-0'>
						<div className=' border-b  border-[#F0F0F0] rounded-b-xl'>
							<PaginatedTable
								columns={CASE_CAUSELIST_COLUMNS}
								data={data}
								totalPages={totalPages}
								fetchData={fetchData}
								isLoading={isLoading}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Judges;
